import React, {useEffect} from 'react';
import { useDispatch } from 'react-redux';
import { updateBreadcrumb } from './store/breadcrumbSlice';

const ContactOptionChat = (props) => {
  const dispatch = useDispatch()
  const contentStrings = props.contentStrings;

  useEffect(() => {
    dispatch(updateBreadcrumb("connect"));

    // EGain Script Start //
    function getEgainLocale() {
       var locale = nortonAnalytics.site_language + nortonAnalytics.site_country;
       var defaultMapping = {
        'cscz': 'cs-CZ',
        'dadk': 'da-DK',
        'dede': 'de-DE',
        'enus': 'en-US',
        'eses': 'es-ES',
        'esmx': 'es-ES',
        'fifi': 'fi-FI',
        'frca': 'fr-CA',
        'frfr': 'fr-FR',
        'huhu': 'hu-HU',
        'itit': 'it-IT',
        'jajp': 'ja-JP',
        'kokr': 'ko-KR',
        'nlnl': 'nl-NL',
        'nono': 'nb-NO',
        'plpl': 'pl-PL',
        'ptbr': 'pt-BR',
        'ptpt': 'pt-PT',
        'roro': 'ro-RO',
        'ruru': 'ru-RU',
        'sksk': 'sk-SK',
        'svse': 'sv-SV',
        'trtr': 'tr-TR',
        'zhcn': 'zh-CN',
        'zhhk': 'zh-TW',
        'zhtw': 'zh-TW'
      };
      try {
        return defaultMapping[locale];
      } catch (err) {
        return "en-US";
      }
    };

    function getEgainEntryPointID() {
      if ( (window.location.host === "support.norton.com") || (window.location.host === "sp-preview.nsse.np.norton.com") ) {
        return (contentStrings['egain_entrypoint_prod'])
      } else {
        return (contentStrings['egain_entrypoint_nonprod'])
      }
    };

    function getEgainServerUrl() {
      if ( (window.location.host === "support.norton.com") || (window.location.host === "sp-preview.nsse.np.norton.com") ) {
        return "https://support-digital.norton.com/system";
      } else {
        return "https://support-devdigital.norton.com/system";
      }
    };

    /* eGain Chat server */
    window.egainDockChat = window.egainDockChat || {};
    window.egainDockChat.serverURL = getEgainServerUrl();
    /* eGain Chat Entry Point*/
    window.egainDockChat.EntryPointId = getEgainEntryPointID();
    /* eGain Chat Locale*/
    window.egainDockChat.Locale  = getEgainLocale();
    /* eGain template name*/
    window.egainDockChat.Template = "nll";
    /* Set to true to enable posting attributes to templates*/
    window.egainDockChat.PostChatAttributes = true;
    window.egainDockChat.IntegratedEntryPoint  = "false";
    /* eGain video chat parameters */
    window.egainDockChat.VChatParams = '';
    /* Set to true if custom button is used to launch docked chat */
    window.egainDockChat.UseCustomButton=true; //if norton use our own button or text
    /* Method to set customer Parameters. To be called by client website. All the parameters specified in application-chat-defaults must be set here.*/
    window.egainDockChat.SetCustomerParameters = function (egainAttributeName, attributeValue) {
      if (!window.egainDockChat.SetParameter) {
        window.egainDockChat.CallQueue = window.egainDockChat.CallQueue || [];
        window.egainDockChat.CallQueue.push({name:'SetParameter', args:[egainAttributeName,attributeValue]});
      } else {
        window.egainDockChat.SetParameter(egainAttributeName,attributeValue);
      }
    };
    /* Method to be called on click of custom button to launch chat in docked mode */
    window.egainDockChat.openHelp = function() {
      window.egainDockChat.IsChatLaunched = true;
      startChat();
    };

    /* eGain system Name. It should be matching cname with your launching page like https://digital.surfeasy.com/system or https://digital.nortonlifelock.com/system or https://digital.lifelock.com/system or https://support-digital.norton.com/system  */
    const EGAIN_CONTEXT = "/egain";

    if (!window.egainDockChat.UseCustomButton) {
      startChat();
    }

    function startChat() {
      if (!window.egainDockChat.launchChat) {
        window.egainDockChat.CallQueue = window.egainDockChat.CallQueue || [];
        window.egainDockChat.CallQueue.push({name:'launchChat', args:[]});
      } else {
        window.egainDockChat.launchChat();
      }
    }

    var lg = nortonAnalytics.site_language;
    var ct = nortonAnalytics.site_country;
    var chatEndUrl = window.location.protocol+"//"+window.location.host+"/osp/"+lg+"/"+ct+"/chat/end?entrysrc=empower"
    var userAgent = navigator.userAgent;
    var empowerEmail = "default.empower"+Math.floor(10000000 + Math.random() * 900000)+"@nortonlifelock.com";
    window.egainDockChat.SetCustomerParameters("subject", "empower");
    window.egainDockChat.SetCustomerParameters("full_name", "member");
    window.egainDockChat.SetCustomerParameters("email_address", empowerEmail);
    window.egainDockChat.SetCustomerParameters("site", window.location.host); //dynamic pop nortonanalytic or domain
    window.egainDockChat.SetCustomerParameters("lg", lg);
    window.egainDockChat.SetCustomerParameters("browseros", userAgent);
    window.egainDockChat.SetCustomerParameters('end_chat_url', chatEndUrl);

    window.egainDockChat.SetAdditionalAttributes = function (attributeName, attributeValue) {
      if (!window.egainDockChat.SetAttribute) {
        window.egainDockChat.CallQueue = egainDockChat.CallQueue || [];
        window.egainDockChat.CallQueue.push({name: 'SetAttribute', args: [attributeName, attributeValue]});
      } else {
        window.egainDockChat.SetAttribute(attributeName, attributeValue);
      }
    };

    window.egainDockChat.SetAdditionalAttributes('site',  window.location.host);

    function resizeChatWindow() {
      const eventMethod = window.addEventListener ? 'addEventListener' : 'attachEvent';
      const eventer = window[eventMethod];
      const messageEvent = eventMethod == 'attachEvent' ? 'onmessage' : 'message';

      // Listen to message from child window
      eventer(messageEvent, function(e) {
        try {
          if (e.data.indexOf('$') != -1) {
            return;
          }
          const message = JSON.parse(e.data);
          const chatWrapper = document.getElementById('egain-chat-wrapper');

          if (message.Method == 'RESIZE_WINDOW') {
            if (message.Key === 'EG_MAXIMIZE') {
              const interval = window.setInterval(alignChatWindow, 0);

              function alignChatWindow() {
                try {
                  chatWrapper.style.maxHeight = 'calc(100% - 110px)';// Modify height of chat window
                  chatWrapper.style.maxWidth = 'calc(343px + 16%)';// Modify width of chat window
                  clearInterval(interval);
                } catch (e) {
                clearInterval(interval);
                }
              }
            }
          }
        } catch (e) {
        }
      }, false);
    }
    resizeChatWindow();

    var EG_ACT_ID = "EG94020756";
    (function(e, f) {
      var d, c, b, a = e.createElement("iframe");
      a.src = "about:blank";
      a.title = "eGain OneTag - Products Assistant";
      a.setAttribute("aria-hidden", "true");
      a.id = "egot_iframe";
      (a.frameElement || a).style.cssText = "width:0;height:0;border:0;display:none";
      b = e.getElementsByTagName("script");
      b = b[b.length - 1];
      b.parentNode.insertBefore(a, b);
      try {
        c = a.contentWindow.document
      } catch (g) {
        d = e.domain, a.src = "javascript:var d=document.open();d.domain='" + d + "';void(0);", c = a.contentWindow.document
      }
      c.open()._l = function() {
        var a = this.createElement("script");
        d && (this.domain = d);
        a.src = f;
        this.isEGFIF = !0;
        this.body.appendChild(a)
      };
      c.write('<body onload="document._l();" style="margin:0px">');
      c.close()
    })(document, "//analytics.analytics-egain.com/onetag/" + EG_ACT_ID); 
    // EGain Script End //

  }, []);

  const openChat = () => {
    window.egainDockChat.openHelp();

    // Analytics: Fire event77 when Chat CTA btn is clicked
    s.events = "event77";
    s.tl();
  }
  
  return (
    <div id="contact-chat-details">
      <div className="contact-subheader contact-pt-50 contact-pb-25"><img className="contact-details-logo" src="data:image/png;base64,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"/>{contentStrings['connect-chat-subheader']}</div>
      <div className="contact-details-paragraph">{contentStrings['connect-chat-para']}</div>
      <div className="contact-details-text-bold" id="contact-chat-case-id-number"></div>
      <a><div id="contact-chat-cta-btn" onClick={openChat}>{contentStrings['connect-chat-btn']}</div></a>
      <div id="contact-popup-notice">{contentStrings['connect-chat-popup-blocker']}</div>
    </div>
  )
}
export default ContactOptionChat